import React from "react";
import { CustomDialog, FormCorrespondanceFichier } from "..";
import { Fichier } from "../../interfaces/fichier";

interface ModalCorrespondanceFichierProps {
  closeModalCorrespondance: () => void;
  modalIsOpenCorrespondance: boolean;
  selectedFiles: Fichier[];
  setSelectedFiles: any;
  setLoading: (newvalue: boolean) => void;
}
const ModalCorrespondanceFichier = ({
  closeModalCorrespondance,
  modalIsOpenCorrespondance,
  selectedFiles,
  setSelectedFiles,
  setLoading,
}: ModalCorrespondanceFichierProps) => {
  return (
    <CustomDialog
      header="Correspondance fichier avec classeur"
      visible={modalIsOpenCorrespondance}
      closeModalDialog={() => {
        closeModalCorrespondance();
      }}
    >
      <div className="w-full h-full ">
        <div className="p-6 space-y-6">
          <FormCorrespondanceFichier
            closeModalCorrespondance={closeModalCorrespondance}
            selectedFiles={selectedFiles}
            setSelectedFiles={setSelectedFiles}
            setLoading={setLoading}
          />
        </div>
      </div>
    </CustomDialog>
  );
};

export default ModalCorrespondanceFichier;
